// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"dd8e263d","739":"0ccfbf3d"}[chunkId] + ".chunk.js";
};